<div class="tab-content" [class.loading]="loading">
  @if (loading) {
    <svg lucideLoaderCircle class="tab-loading-spinner lucide-spin"></svg>
  }
  @if (!loading) {
    <p class="double-margin-bottom">
      Set a default custom suffix for Recovery S3 buckets managed by Arpio.
      <a href="{{ uiService.s3BucketSuffix }}">Learn more</a>
    </p>
    <form [formGroup]="resourceConfigsFormModel" (ngSubmit)="updateResourceConfigs()">
      <div>
        <label class="margin-top" for="s3-recovery-bucket-suffix">S3 recovery bucket suffix</label>
      </div>
      <input
        id="s3-recovery-bucket-suffix"
        formControlName="s3RecoveryBucketSuffix"
        class="arpio-input spacer"
        placeholder="dr"
        minlength="2"
        maxlength="12"
      />
      @if (canManageResourceDefaults) {
        <div>
          <button
            busy-button
            [busy]="submitting"
            [done]="doneSubmitting"
            type="submit"
            id="update-resource-defaults-button"
            class="arpio-button margin-top"
            [disabled]="updateButtonDisabled"
            (click)="updateResourceConfigs()"
          >
            Update
          </button>
        </div>
      }
    </form>
  }
</div>
